<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog
      ref="dialogEl"
      as="div"
      class="relative z-[999]"
      :initial-focus="dialogEl"
      @close="showMenu"
    >
      <div
        class="fixed inset-0 top-header-top-with-discount border-t border-white"
      >
        <div class="h-full items-center justify-center text-center">
          <TransitionChild
            as="template"
            enter="transition duration-250 ease-out"
            enter-from="-translate-x-full opacity-0"
            enter-to="translate-x-0 opacity-100"
            leave="transition duration-250 ease-in"
            leave-from="translate-x-0 opacity-100"
            leave-to="-translate-x-full opacity-0"
            @after-enter="onAfterEnter"
          >
            <DialogPanel
              class="relative flex h-full w-full transform flex-col overflow-auto overflow-x-hidden bg-primary text-left align-middle shadow-xl transition-all"
            >
              <div
                class="container max-md:max-w-full pt-4"
                :class="{ 'flex-auto': !menuVisible }"
              >
                <LazyCommonAppHeaderSearchMobile
                  @setSearchLength="onSearchLength"
                  @result-item-click="closeModal"
                  @goToSearchPage="goToSearchPageHandlerLocal"
                />
              </div>
              <LazyCommonAppHeaderBurgerMenu
                v-show="menuVisible"
                class="flex-auto"
                @eventRedirect="closeModal"
              />
              <div
                class="sticky bg-primary py-2.5 w-full bottom-0 container z-1 shadow-[0_-2px_4px_#262626]"
              >
                <ul class="flex items-center gap-x-4 ui-text-xs text-white">
                  <li>
                    <NuxtLink
                      v-if="!generalStore.isAuthenticated"
                      class="flex items-center gap-2"
                      :to="localePath('/sign-in')"
                      aria-label="login"
                      data-e2e-cta="profile-icon"
                      @click="closeModal"
                    >
                      <span>{{ $t("login") }}</span>
                    </NuxtLink>
                    <NuxtLink
                      v-else
                      class="flex items-center gap-2"
                      :to="localePath('/profile')"
                      aria-label="login"
                      data-e2e-cta="profile-icon"
                      @click="closeModal"
                    >
                      <span>
                        {{ $t("account") }}
                      </span>
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink
                      class="flex items-center gap-2"
                      aria-label="wishlist"
                      :to="localePath('/favorites')"
                      data-e2e-cta="wishlist"
                      @click="closeModal"
                    >
                      <span>{{ $t("wishlist") }}</span>
                    </NuxtLink>
                  </li>
                </ul>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
} from "@headlessui/vue";

const dialogEl = ref();

const menuVisible = ref(true);

const { goToSearchPageHandler } = useGoToSearchPage();

const { lg2AndUp } = useAppBreakpoints();

const props = defineProps<{ modelValue: boolean; logoSrc: string }>();
const emit = defineEmits(["update:modelValue"]);
const localePath = useLocalePathPolyfill();
const generalStore = useGeneralStore();

const isOpen = computed({
  get() {
    return props.modelValue;
  },
  set(value: boolean) {
    emit("update:modelValue", value);
  },
});

watch(lg2AndUp, () => {
  if (lg2AndUp.value) {
    closeModal();
  }
});

watch(
  () => props.modelValue,
  () => {
    if (!props.modelValue) {
      closeModal();
    }
  },
);

function closeModal() {
  isOpen.value = false;
  menuVisible.value = true;
}

function onAfterEnter() {
  setTimeout(() => {
    const inertEl = document.querySelector("[inert]");
    if (inertEl) {
      inertEl.removeAttribute("inert");
    }
    const hiddenEl = document.querySelector(".drawer-wrap [hidden]");
    if (hiddenEl) {
      hiddenEl.remove();
    }
  }, 0);
}

function showMenu() {
  menuVisible.value = true;
}

function onSearchLength(value: string) {
  menuVisible.value = !value;
}

function goToSearchPageHandlerLocal(searchValue: string) {
  goToSearchPageHandler(searchValue);
  closeModal();
}
</script>
